module.exports = __webpack_public_path__ + "img/facebook-f.4e402e76.svg";